import script from "./ReviseStore.vue?vue&type=script&setup=true&lang=js"
export * from "./ReviseStore.vue?vue&type=script&setup=true&lang=js"

import "./ReviseStore.vue?vue&type=style&index=0&id=f979dcc0&lang=css"

const __exports__ = script;

export default __exports__